import { StatusBadgeColorVariant } from "@/shared/components/StatusBadge";
import {
  PathPickOrderStatus,
  PathPickOrderStatusGroup,
} from "@/features/pathpick/features/order-history/types";

// 주문 이력 i18n 네임스페이스 — 상세 화면(features/detail/constants)이 여기서 접두사를 파생한다.
export const ORDER_HISTORY_KEY = "path_pick:order_history.";

// 상태 → 배지 라벨 키/색상
export const ORDER_STATUS_META: Record<
  PathPickOrderStatus,
  { labelKey: string; colorVariant: StatusBadgeColorVariant }
> = {
  REQUESTED: {
    labelKey: `${ORDER_HISTORY_KEY}status_requested`,
    colorVariant: "blue",
  },
  REMITTANCE_REQUESTED: {
    labelKey: `${ORDER_HISTORY_KEY}status_deposit_requested`,
    colorVariant: "yellow",
  },
  REMITTED: {
    labelKey: `${ORDER_HISTORY_KEY}status_deposit_confirmed`,
    colorVariant: "green",
  },
  QUANTITY_CHECKING: {
    labelKey: `${ORDER_HISTORY_KEY}status_quantity_checking`,
    colorVariant: "blue",
  },
  QUANTITY_CONFIRMED: {
    labelKey: `${ORDER_HISTORY_KEY}status_quantity_confirmed`,
    colorVariant: "blue",
  },
  SHIPPING: {
    labelKey: `${ORDER_HISTORY_KEY}status_shipping`,
    colorVariant: "blue",
  },
  COMPLETED: {
    labelKey: `${ORDER_HISTORY_KEY}status_completed`,
    colorVariant: "green",
  },
  CANCELED: {
    labelKey: `${ORDER_HISTORY_KEY}status_canceled`,
    colorVariant: "red",
  },
};

// 서버가 아직 매핑되지 않은 상태를 내려줄 경우의 배지 폴백
export const DEFAULT_ORDER_STATUS_COLOR_VARIANT: StatusBadgeColorVariant =
  "gray";

// 상태 필터 버튼 — value가 곧 status_group 쿼리 파라미터 값이다(ALL은 파라미터 생략).
export interface OrderStatusFilter {
  value: PathPickOrderStatusGroup;
  labelKey: string;
}

export const ORDER_STATUS_FILTERS: OrderStatusFilter[] = [
  { value: "ALL", labelKey: `${ORDER_HISTORY_KEY}filter_all` },
  {
    value: "QUANTITY_CHECKING",
    labelKey: `${ORDER_HISTORY_KEY}filter_quantity_check`,
  },
  {
    value: "REMITTANCE_NEEDED",
    labelKey: `${ORDER_HISTORY_KEY}filter_payment`,
  },
  { value: "SHIPPING", labelKey: `${ORDER_HISTORY_KEY}filter_shipping` },
  { value: "COMPLETED", labelKey: `${ORDER_HISTORY_KEY}filter_completed` },
  { value: "CANCELED", labelKey: `${ORDER_HISTORY_KEY}filter_canceled` },
];

// 리스트/헤더 공통 그리드 컬럼
export const ORDER_HISTORY_TEMPLATE_COLUMNS =
  "160px minmax(320px, 1fr) 120px 90px 170px 120px";
